import React from "react";

import SectionHeader from "components/common/section-header/section-header";

import Speaker from "assets/img/Group 133.svg";
import "./section-one.styles.scss";

const SectionOne = () => {
  return (
    <div className="services-section">
      <div className="container mt-5">
        <div className="row">
          <div className="col-lg-6">
            <SectionHeader
              main="Digital Marketing Agency"
              headerText="Complete Digital Marketing Solution"
            />
          </div>
          <div className="col-lg-6">
            <p className="mt-5">
              Unlock your brand&apos;s full potential with our comprehensive
              digital marketing solutions. From strategic planning to effective
              execution, we drive growth and maximize your online presence.
            </p>
          </div>
        </div>

        <div className="services-section_cards">
          <div className="row">
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>Social Media Marketing</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>Website Design & Development</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>SEO and SEM</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>Graphic Design</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>Graphic Design</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>Graphic Design</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionOne;
